import HundredBricksAPIError from '../HundredBricksAPIError';
class EnrollmentStatusError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('EnrollmentStatusError', ...args);
    }
}
export default EnrollmentStatusError;
